import React from "react";
import NewsArticleLayout from "../../../components/updated-article/NewsArticleLayout.component";

const isNew = true;
const href = "/ratesheet/20230328-Rate-Sheet.pdf";
const date = "28.03.2023";

const Article = () => (
  <NewsArticleLayout href={href} date={date} isNew={isNew}>
    <h1 className="page-title">Changes to our mortgage products</h1>

    <br />
    <p>With effect from Tuesday 28 March 2023 we will be making the following changes to our range:</p>

    <p>
      <strong>Summary of changes</strong>
    </p>

    <p><strong>UK Residential Existing Customer Switching Range</strong></p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>2 Year Fixed Standard at 70%, 75%, 80% and 90% LTV have reduced</li>
      <li>3 Year Fixed Fee Saver at 90% LTV has reduced</li>
      <li>3 Year Fixed Standard at 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Premier Exclusive at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
    </ul>

    <p><strong>UK Residential Existing Customer Borrowing More Range</strong></p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>2 Year Fixed Standard at 70%, 75%, 80% and 90% LTV have reduced</li>
      <li>3 Year Fixed Fee Saver at 90% LTV has reduced</li>
      <li>3 Year Fixed Standard at 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Premier Exclusive at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
    </ul>

    <p><strong>UK Residential First Time Buyer Range</strong></p>
    <ul>
      <li>2 Year Fixed Standard at 90% LTV has reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Premier Exclusive at 60%, 70% and 75% LTV have reduced</li>
    </ul>

    <p><strong>UK Residential Home Mover Range</strong></p>
    <ul>
      <li>2 Year Fixed Standard at 90% LTV has reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75%, 80%, 85% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Premier Exclusive at 60%, 70% and 75% LTV have reduced</li>
    </ul>

    <p><strong>UK Residential Remortgage Range</strong></p>
    <ul>
      <li>5 Year Fixed Fee Saver at 60%, 70%, 75% and 90% LTV have reduced</li>
      <li>5 Year Fixed Standard at 70%, 75%, 80% and 85% LTV have reduced</li>
      <li>5 Year Premier Exclusive at 70%, 75%, 80% and 85% LTV have reduced</li>
    </ul>

    <p><strong>International Residential Range</strong></p>
    <ul>
      <li>5 Year Fixed Fee Saver at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 70% and 75% LTV have reduced</li>
      <li>5 Year Fixed Premier Standard at 60%, 70% and 75% LTV have reduced</li>
    </ul>

    <p><strong>UK Buy to Let </strong><strong>Existing Customer Switching</strong><strong> Range</strong></p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>

    <p><strong>UK Buy to Let </strong><strong>Existing Customer Borrowing More</strong><strong> Range</strong></p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>

    <p><strong>UK Buy to Let Purchase Range</strong></p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>2 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>

    <p><strong>UK Buy to Let Remortgage Range</strong></p>
    <ul>
      <li>2 Year Fixed Fee Saver at 60% LTV has reduced</li>
      <li>2 Year Fixed Standard at 60% LTV has reduced</li>
      <li>5 Year Fixed Fee Saver at 60%, 65% and 75% LTV have reduced</li>
      <li>5 Year Fixed Standard at 60%, 65% and 75% LTV have reduced</li>
    </ul>

    <p>There are no changes to any other interest rates or our fixed rate end dates at this time.</p>
    <p>An updated mortgage rate sheet will be published on Tuesday 28 March to reflect these changes.</p>
  </NewsArticleLayout>
);

export default Article;
